module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/7-7546ef998d6c152eb4cf613ab859d5e5.png";